// providers/auth/AuthContext.tsx
import { useEffect, useState } from 'react'
import { getSessionApi } from '@/api/auth.api'
// import type { Role } from '@/api/auth'
import { normalizeRole } from '@/utils/normalizeRole'
import { useUserStore } from '@/stores/user.store'
import type { User } from '@/common/user.common'

export const LOCAL_STORAGE_KEY = 'sib_user'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { setLoading, setUser } = useUserStore()

  useEffect(() => {
    async function restore() {
      setLoading(true)
      try {
        const storedRaw = localStorage.getItem(LOCAL_STORAGE_KEY)
        let stored: Partial<User> | null = null
        if (storedRaw) stored = JSON.parse(storedRaw)

        const session = await getSessionApi()

        const normalizedRole = normalizeRole(session.user.role)

        setUser({ ...session.user, role: normalizedRole })
      } catch (err) {
        // TODO: Replace console.error with proper logging tool once available
        console.error('[AuthContext] Session restore failed:', err)
        // The user may have signed in while this restore was still in flight (its 401 and
        // refresh can take seconds). Clearing then would log them straight back out.
        if (!useUserStore.getState().user) setUser(null)
      } finally {
        setLoading(false)
        useUserStore.setState({ sessionRestored: true })
      }
    }

    restore()
  }, [])

  return children
}
